import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { PreviewSummary } from "@/components/shapes/shared/card-preview-parts";
import { useIntegrationStore } from "@/stores/integration-store";
import { useT } from "@/i18n";
import { framesConnectionMessages } from "@/i18n/messages/frames-connection";

function activeCount(
  connections: ReturnType<typeof useIntegrationStore.getState>["connections"],
): number {
  let count = 0;
  for (const connection of connections.values()) {
    if (connection.status === "active") count += 1;
  }
  return count;
}

/**
 * Connected apps: the title and how many are connected. Nothing is said
 * before the store has any (it loads with the live frame or Settings).
 */
export function ConnectionCardPreview({ frame, density }: CardPreviewProps) {
  const t = useT(framesConnectionMessages);
  const active = useIntegrationStore((state) => activeCount(state.connections));
  const summary = active === 0 ? "" : t("appsConnected", { count: active });
  return <PreviewSummary frame={frame} density={density} summary={summary} />;
}
